import Vue from "vue";
import Vuex from "vuex";

import auth from "./modules/auth";
import {
  checkUserLogin,
  getClient,
  getProjectInfo,
  login,
  getAuthUserInfo,
  getUserMenuPower,
  getStations,
  getStationRank,
  getAlarmList,
  getStationCurStatus,
  getStationData,
  getStationSampleDevice,
  getGfStaions,
  getGfStationData
} from "@/api/api";
import router from "@/router";
import moment from "moment";
import { showNocifaction } from "@/utils/commonNotifaction";
Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

function avg_li(li) {
  var sum = 0;
  var count = 0;
  for (let i of li) {
    sum += i;
    count++;
  }
  return Math.round(sum / count);
}
/* eslint-disable no-new */
export default new Vuex.Store({
  modules: {
    auth
  },
  strict: debug,
  state: {
    token: null,
    authUserInfo: {},
    clientInfo: {},
    user_power: {},
    page_config: _page_config,
    time_type: _page_config.time_type,
    sensortype: _page_config.sensortype,
    gfSensortype: [_page_config.sensortype],
    sensortypes: _page_config.sensortypes,
    stations: [],
    station_dict: {},
    loading: true,
    data_time: "0", //moment().format("YYYY-MM-DD HH:mm:ss"),
    timeRange: [moment().subtract(24, "hours"), moment()],
    showMapTile: _page_config.tileDefault,
    showHYBRID_MAP: false,
    showGfStation: false,
    stationData: null,
    sampleDevices: {},
    gfStations: [],
    gfStationData: [],
    abnormalList: [],
    colorRange: [0, 700],
    virtualStations: [],
    virtualStationData: [],
    dataTypeRange: [],
    mapInfo: null,
    locateAlarm: null,
    mapMode: "current",
    topicStatus: true
  },
  getters: {
    pageTitle: state => {
      return _page_config.page_title;
    }
  },
  mutations: {
    setToken(state, token) {
      state.token = token;
    },
    setClientInfo(state, data) {
      state.clientInfo = data;
    },
    setProjectInfo(state, data) {
      state.projectInfo = data;
    },
    setProjectName(state, data) {
      _page_config.page_title = data;
    },
    setAuthUserInfo(state, data) {
      state.authUserInfo = data;
    },
    updateUserMenuPower(state, value) {
      state.user_power = value;
    },
    setStations(state, d) {
      state.stations = d;
    },
    setStationDict(state, d) {
      state.station_dict = d;
    },
    setLoading(state, info) {
      state.loading = info;
    },
    setShowMapTile(state, v) {
      state.showMapTile = v;
    },
    setStationData(state, v) {
      state.stationData = v;
    },
    setVirtualStationData(state, v) {
      state.virtualStationData = v;
    },
    setSensorTypes(state, v) {
      _page_config.sensortypes = v;
      state.sensortypes = v;
    },
    setTimeType(state, v) {
      state.time_type = v;
    },
    setSensortype(state, v) {
      state.sensortype = v;
    },
    setGfSensortype(state, v) {
      state.gfSensortype = v;
    },
    setTimeRange(state, v) {
      state.timeRange = v;
    },
    setAbnormalList(state, v) {
      state.abnormalList = v;
    },
    setColorRange(state, v) {
      state.colorRange = v;
    },
    setVirtualStations(state, v) {
      state.virtualStations = v;
    },
    setDataTime(state, v) {
      state.data_time = v;
    },
    setShowHYBRID_MAP(state, v) {
      state.showHYBRID_MAP = v;
    },
    setShowGfMAP(state, v) {
      state.showGfStation = v;
    },
    setDataTypeColorRange(state, data) {
      state.dataTypeRange = data;
    },
    openMapWindow(state, data) {
      state.mapInfo = data;
    },
    updateLocateAlarm(state, data) {
      state.locateAlarm = data;
    },
    updateMapMode(state, data) {
      state.mapMode = data;
    },
    setStationSampleDeviceStatus(state, data) {
      state.sampleDevices = data;
    },
    setGfStations(state, data) {
      state.gfStations = data;
    },
    setGfStationData(state, data) {
      state.gfStationData = data;
    }
  },
  actions: {
    async init({ dispatch, commit }, callback) {
      // try {
      var res = await checkUserLogin();
      if (res.data.code === 200) {
        Promise.all([
          await dispatch("getClient", localStorage.username),
          await dispatch("getProjectInfo"),
          await dispatch("getAuthUserInfo"),
          await dispatch("getUserMenuPower"),
          await dispatch("getColorRange"),
          showNocifaction(),
          await dispatch("getStations"),
          await dispatch("getGfStationsInfo"),
          await dispatch("getGfStationData"),
          // await dispatch("getStationData"),
          await dispatch("getAbnormalStation")
        ])
          .then(() => {
            commit("setLoading", false);
          })
          .catch(e => {
            console.log(e);
            commit("setLoading", false);
          });
        callback && callback(true);
      } else {
        router.replace({ name: "login" });
        callback && callback(false);
      }
      // } catch (e) {
      //   console.log(e);
      //   callback && callback()
      //   router.replace({ name: "login" });
      // }
    },
    getClient(context, username) {
      return getClient(username).then(c => {
        if (c.data.code === 200) {
          context.commit("setClientInfo", c.data.data);
        }
      });
    },
    getProjectInfo(context) {
      return getProjectInfo(context.state.clientInfo.proId).then(res => {
        const { code, msg, data } = res.data;
        if (code == 200) {
          let name = (data.city || "") + (data.county || "");
          let regionId = data.countyCode || data.cityCode;
          data.name = name;
          data.regionId = regionId;
          context.commit("setProjectInfo", data);

          // context.commit("setProjectName", data.projName);

          var sensortypes = data.sensorType.split(",");
          console.log(sensortypes, "...........");
          sensortypes = G_SENSOR_DATA_TYPE_INFO.filter(
            x => sensortypes.indexOf(x.value) !== -1
          );

          this.commit("setSensorTypes", sensortypes);
        } else {
          message.error(msg);
        }
      });
    },
    getAuthUserInfo({ state, commit }) {
      return getAuthUserInfo(state.clientInfo.proId).then(x => {
        let data = x.data.data;
        commit("setAuthUserInfo", data);
      });
    },
    getUserMenuPower(context) {
      return getUserMenuPower().then(function(x) {
        let x_data = x.data.data;
        var data = {};
        var controls = {};
        if (x_data.controls) {
          for (var i in x_data.controls) {
            controls[x_data.controls[i].name] = true;
          }
        }
        if (x_data.menus) {
          for (let item of x_data.menus) {
            let childs = item.childs;
            childs = childs.sort((x, y) => {
              return x.weight - y.weight;
            });
            item.childs = childs;
          }
        }
        data.menus = x_data.menus || [];
        data.controls = controls;

        context.commit("updateUserMenuPower", data);
        return data;
      });
    },
    getColorRange(context) {
      let dataTypeRange = {};
      // let data = pmcolor_range;
      // for (let i of data) {
      //   dataTypeRange[i.value] = { max: i.max, min: i.min };
      // }
      context.commit("setDataTypeColorRange", dataTypeRange);
    },
    getStations(context) {
      let group_id = context.state.authUserInfo.devGroupIds;
      group_id = group_id.split(",")[0]; // 多个设备组使用第1个
      return getStations(group_id)
        .then(s => {
          let stations = s.data;
          stations = stations.filter(x => x.is_virtual !== 1);

          let station_dict = {};
          for (let i of stations) {
            station_dict[i.station_id] = i;
          }
          context.commit("setStations", stations);
          context.commit("setStationDict", station_dict);
        })
        .catch(err => {
          console.log(err);
        });
    },
    getStationRank(context) {
      return getStationRank({
        groups: context.state.authUserInfo.devGroupIds,
        time_type: context.state.time_type,
        timepoint: context.state.data_time
      }).then(x => {
        context.commit("setStationData", x.data);
      });
    },
    getStationData(context, alrmTime) {
      const time_type =
        context.state.time_type === "real" ? "min" : context.state.time_type;
      let time =
        context.state.page_config.minToNow &&
        time_type === "min" &&
        context.state.mapMode !== "alarm"
          ? "now"
          : context.state.data_time;
      if (alrmTime) {
        time = alrmTime;
      }
      let group_id = context.state.authUserInfo.devGroupIds;
      group_id = group_id.split(",")[0]; // 多个设备组使用第1个
      return getStationData({
        time: time,
        time_type: time_type,
        group_id: group_id
      }).then(x => {
        // 没有数据会返回空数组，有数据为对象，
        const res_is_data = Array.isArray(x.data)
          ? x.data.length
          : Object.keys(x.data);
        let station_data = [];
        if (res_is_data) {
          let station_dict = context.state.station_dict;
          let columns = x.data.columns;
          let values = x.data.values;

          for (let i of values) {
            let d = {};
            let info;
            for (let c_idx in columns) {
              let c = columns[c_idx];
              let v = i[c_idx];
              d[c] = v == -1 ? "--" : v;
              if (c == "station_id") {
                info = station_dict[v];
                if (!info) continue;
                d.sn = info.DevSN;
                d.name = info.name;
                d.Lng = info.Lng;
                d.Lat = info.Lat;
              }
            }
            if (!info) continue;
            station_data.push(d);
          }
          context.commit("setStationData", station_data);
        } else {
          context.commit("setStationData", []);
        }
        return station_data;
      });
    },
    getAbnormalStation(context, time) {
      let group_id = context.state.authUserInfo.devGroupIds;
      let start = moment()
        .subtract(5, "days")
        .format("YYYY-MM-DD HH:mm:ss");
      let end = moment().format("YYYY-MM-DD HH:mm:ss");
      let abnormal_list = [];
      getAlarmList({ start: start, end: end, groups: group_id }).then(x => {
        getStationCurStatus({ group_id }).then(y => {
          for (let i of x.data) {
            // let push_data = {
            //   name: i.station_name,
            //   sn: i.sn,
            //   time: i.start_time,
            //   type: i.type_name,
            //   value: i.value
            // };
            let push_data = [
              i.start_time,
              i.station_name,
              i.type_name,
              i.value
            ];
            abnormal_list.push(i);
          }
          for (let i of y.data) {
            if (y.type_id !== 2) continue;
            // let push_data = {
            //   name: i.name4,
            //   sn: i.DevSN,
            //   time: i.start_time,
            //   type: i.type,
            //   value: i.time_diff
            // };
            let push_data = [i.start_time, i.name4, i.type, i.time_diff];
            abnormal_list.push(i);
          }
          context.commit("setAbnormalList", abnormal_list);
        });
      });
    },
    getStationSampleDeviceStatus(context) {
      getStationSampleDevice()
        .then(d => {
          context.commit("setStationSampleDeviceStatus", d.data);
        })
        .catch(e => {
          console.log(e);
        });
    },
    getGfStationsInfo(context) {
      if (context.state.user_power.controls.showGf) {
        getGfStaions(context.state.projectInfo.regionId)
          .then(d => {
            context.commit("setGfStations", d.data.data);
          })
          .catch(err => console.log(err));
      }
    },
    getGfStationData(context) {
      if (context.state.user_power.controls.showGf) {
        getGfStationData(context.state.projectInfo.regionId)
          .then(d => {
            context.commit("setGfStationData", d.data.data);
          })
          .catch(err => console.log(err));
      }
    }
  }
});
